module.exports = __webpack_public_path__ + "img/rjt.79c6f163.svg";